import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const Device_Interface = () => {
    const [fpsId, setFpsId] = useState('');
    const [loading, setLoading] = useState(false);
    const [deviceDetails, setDeviceDetails] = useState(null);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [fpsFocused, setFpsFocused] = useState(false);
    const [terminalFocused, setTerminalFocused] = useState(false);
    const [showDeviceForm, setShowDeviceForm] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [resultMessage, setResultMessage] = useState('');
  
    const handleBack = () => {
        window.history.back();
    };

    const validateFpsId = () => {
        if (!fpsId || fpsId.trim() === '') {
            setError('Please Fill FPS ID');
            document.getElementById('fps_id').style.border = "1px solid red";
            document.getElementById('fps_id').focus();
            return false;
        }
      
        if (!/^\d{1,12}$/.test(fpsId)) {
            setError('Please enter the FPS ID');
            document.getElementById('fps_id').style.border = "1px solid red";
            document.getElementById('fps_id').focus();
            return false;
        }
      
        setError('');
        document.getElementById('fps_id').style.border = "";
        return true;
    };

    const fetchFpsDetails = async () => {
        if (!validateFpsId()) return;
      
        setLoading(true);
        setDeviceDetails(null);
        setMessage('');
        setShowDeviceForm(false);
        setShowResult(false);
      
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/fps-mapping/${fpsId}`, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            });
          
            if (response.data.check === 1) {
                setDeviceDetails(response.data);
                setShowDeviceForm(true);
                setFpsId(fpsId);
                setMessage('');
            } else if (response.data.check === 0) {
                setMessage('Given FPS Details Not Found');
            }
        } catch (error) {
            console.error('Error fetching FPS details:', error);
            if (error.response && error.response.status === 500) {
                setMessage('Error fetching FPS details');
            } else {
                setMessage('Network error. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    const updateDeviceMapping = async () => {
        if (!deviceDetails) return;
      
        if (deviceDetails.terminal_id && deviceDetails.terminal_id.length > 0) {
          
            if (!/^[a-zA-Z0-9]{1,16}$/.test(deviceDetails.terminal_id)) {
                setMessage('Only letters and numbers allowed for Device No');
                document.getElementById('terminal_id').style.border = "1px solid red";
                document.getElementById('terminal_id').focus();
                return;
            }
        }
      
        try {
            const payload = {
                terminal_id: deviceDetails.terminal_id || '',
                fps_id: deviceDetails.fps_id,
                district: deviceDetails.district || ''
            };
          
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/fps-mapping/upsert`, payload, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            });
          
            setResultMessage(response.data.message);
            setShowResult(true);
            setShowDeviceForm(false);
          
            if (response.data.message && response.data.message.includes('Successfully')) {
              
            }
        } catch (error) {
            console.error('Error updating device mapping:', error);
            setResultMessage('Error updating device mapping');
            setShowResult(true);
            setShowDeviceForm(false);
        }
    };

    const handleTerminalIdChange = (e) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '');
      
        setDeviceDetails(prev => ({
            ...prev,
            terminal_id: alphanumericValue.slice(0, 16)
        }));
      
        document.getElementById('terminal_id').style.border = "";
    };

    const resetForm = () => {
        setDeviceDetails(prev => ({
            ...prev,
            terminal_id: ''
        }));
        document.getElementById('terminal_id').style.border = "";
        return false;
    };

    const handleKeyPress = (e) => {
        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleMouseOver = (e) => {
        e.target.select();
    };

    const handleFpsFocus = () => {
        setFpsFocused(true);
    };

    const handleFpsBlur = () => {
        setFpsFocused(false);
    };

    const handleTerminalFocus = () => {
        setTerminalFocused(true);
    };

    const handleTerminalBlur = () => {
        setTerminalFocused(false);
    };

    const headerText = (deviceDetails?.terminal_id || '').trim() === '' ? 'FPS Details' : 'FPS Device Details';

    const handleDeviceBack = () => {
        setShowDeviceForm(false);
        setFpsId('');
        setDeviceDetails(null);
        setMessage('');
    };

    const handleResultBack = () => {
        setShowResult(false);
        setFpsId('');
        setDeviceDetails(null);
        setMessage('');
    };

    return (
        <div>
            {!showResult && (
                <>
                    <br></br>
                    <table width="30%" align="center">
                        <tbody>
                            <tr className="tableheader">
                                <th colSpan="2" >
                                    FPS Device Mapping
                                </th>
                            </tr>
                            <tr>
                                <td>FPS</td>
                                <td>
                                    <input
                                        type="text"
                                        onMouseOver={handleMouseOver}
                                        name="fps_id"
                                        id="fps_id"
                                        required
                                        onKeyPress={handleKeyPress}
                                        maxLength="12"
                                        pattern="\d{1,12}"
                                        value={fpsId}
                                        onChange={(e) => setFpsId(e.target.value)}
                                        onFocus={handleFpsFocus}
                                        onBlur={handleFpsBlur}
                                        style={{
                                            backgroundColor: 'white',
                                            caretColor: fpsFocused ? 'black' : 'transparent'
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr style={{ textAlign: 'center' }}>
                                <td colSpan="2" style={{ padding: '8px' }}>
                                    <button
                                        onClick={fetchFpsDetails}
                                        className="button button2"
                                        style={{ marginRight: "7px" }}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        onClick={handleBack}
                                        className="button button2"
                                    >
                                        Back
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                  
                    {error && (
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                            <font color="red" size="6px">{error}</font>
                        </div>
                    )}
                  
                    <br />
                  
                    {loading && (
                        <div align="center" id="loading" style={{ display: loading ? 'block' : 'none' }}>
                            <CircularProgress />
                        </div>
                    )}
                  
                    <br />
                </>
            )}
          
            {showDeviceForm && deviceDetails && deviceDetails.check > 0 && !showResult && (
                <div style={{ textAlign: 'center' }}>
                    <form onSubmit={(e) => { e.preventDefault(); updateDeviceMapping(); }}>
                        <table width="40%" align="center" >
                            <tbody>
                                <tr className="tableheader">
                                    <th colSpan="2">
                                        {headerText}
                                    </th>
                                </tr>
                                <tr>
                                    <td style={{textAlign: 'left'}}>Device No</td>
                                    <td style={{textAlign: 'left'}}>
                                        <input
                                            type="hidden"
                                            name="fps_id"
                                            id="fps_id"
                                            value={deviceDetails.fps_id || ''}
                                         
                                        />
                                        <input
                                            type="hidden"
                                            name="district"
                                            id="district"
                                            value={deviceDetails.district || ''}
                                        />
                                        <input
                                            type="text"
                                            onMouseOver={handleMouseOver}
                                            name="terminal_id"
                                            id="terminal_id"
                                            maxLength="16"
                                            value={deviceDetails.terminal_id || ''}
                                            onChange={handleTerminalIdChange}
                                            onFocus={handleTerminalFocus}
                                            onBlur={handleTerminalBlur}
                                            style={{
                                                backgroundColor: 'white',
                                                caretColor: terminalFocused ? 'black' : 'transparent'
                                            }}
                                        />
                                        <font color="red">
                                            <span id="msg" style={{ color: 'red', fontSize: '12px' }}>
                                                {deviceDetails.terminal_id && !/^[a-zA-Z0-9]*$/.test(deviceDetails.terminal_id)
                                                    ? 'Only letters and numbers allowed (max 16 characters)'
                                                    : ''}
                                            </span>
                                        </font>
                                    </td>
                                </tr>
                                <tr style={{ textAlign: 'center' }}>
                                    <td colSpan="2" style={{ padding: '8px' }}>
                                        <button
                                            type="submit"
                                            className="button button2"
                                            style={{ marginRight: "7px" }}
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleDeviceBack}
                                            className="button button2"
                                            style={{ marginRight: "7px" }}
                                        >
                                            Back
                                        </button>
                                        <button
                                            type="button"
                                            onClick={resetForm}
                                            className="button button2"
                                        >
                                            Clear
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </div>
            )}
          
            {showResult && (
                <div style={{ textAlign: 'center' }}>
                    <br />
                    <br />
                    <div className="response" style={{ 
                        fontSize: '20px', 
                        color: resultMessage.includes('Successfully') ? '#8B4513' : '#FF0000',
                        padding: '20px',
                        margin: '20px'
                    }}>
                        {resultMessage}
                    </div>
                    <br />
                    <button
                        onClick={handleResultBack}
                        className="button button2"
                    >
                        Back
                    </button>
                </div>
            )}
          
            {!showResult && message && (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <span style={{
                        color: '#8B4513',
                        textDecoration: 'underline',
                        fontWeight: 'bold',
                        fontSize: '20px'
                    }}>
                        {message}
                    </span>
                </div>
            )}
        </div>
    );
};

export default Device_Interface;
